import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Axios from 'axios'


Vue.config.productionTip = false

import "../public/css/materialdesignicons.min.css";
import 'swiper/swiper-bundle.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import $ from 'jquery'

import { BootstrapVue } from 'bootstrap-vue'
var VueScrollTo = require('vue-scrollto');
import Scrollspy from 'vue2-scrollspy';
import VueYoutube from 'vue-youtube'
import vueVimeoPlayer from 'vue-vimeo-player'
import VueMasonry from 'vue-masonry-css'
import scrollReveal from 'scrollreveal'
Vue.prototype.$scrollReveal = scrollReveal()

Vue.use(VueScrollTo, {
  duration: 3000,
  easing: "ease"
})
Vue.prototype.$axios = Axios

Vue.use(BootstrapVue)
Vue.use(Scrollspy);
Vue.use(VueYoutube)
Vue.use(vueVimeoPlayer)
Vue.use(VueMasonry)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
